<template>
  <div class="mobile-box">
      <nav-web style="background-color: #000C2A"></nav-web>
    <div class="mobile-content">
    <div class="m-title-box">
    优质服务
    <div class="m-title-line"></div>
    </div>
    <div class="m-describe">
      极能充五星级充电站全站标配120KW直流快充充电桩，为客户提供快速能源补给服务，配备休息室、卫生间、停车场等服务设施，提供餐饮、购物、汽车维修、包月充电、包月挪车等多种增值服务业务。针对企业客户，提供充值返利、消费返利、协议电价等多种合作模式，确保客户利益最大化。
    </div>
    <div class="m-peculiarity">
      <div class="m-peculiarity-item">
        <div class="m-pe-icon m-iconk2"></div>
        <div class="m-pe-text">
          <div>各项优惠福利</div>
        </div>
      </div>
      <div class="m-peculiarity-item">
          <div class="m-pe-icon m-iconk1"></div>
          <div class="m-pe-text">
              <div>配套服务完善</div>
          </div>
      </div>
    </div>
    <div class="m-data-explain">
        <div class="m-img-big m-de-item-img1"></div>
    </div>

    <div class="m-title-box" style="margin-top: 60px;">
    管理高效化
    <div class="m-title-line"></div>
    </div>
    <div class="m-describe">
      针对企业充电客户，提供员工车队管理、充电子账户管理、托管充电、无感充电等功能，方便企业客户对本单位车辆实现精细化管理，提高企业充电账户安全和使用效率。
    </div>
    <div class="m-peculiarity">
      <div class="m-peculiarity-item">
        <div class="m-pe-icon m-iconk3"></div>
        <div class="m-pe-text">
          <div>员工账号资金管控</div>
        </div>
      </div>
      <div class="m-peculiarity-item">
        <div class="m-pe-icon m-iconk4"></div>
          <div class="m-pe-text">
            <div>员工分时段控制</div>
          </div>
        </div>
      <div class="m-peculiarity-item">
    <div class="m-pe-icon m-iconk5"></div>
    <div class="m-pe-text">
    <div>远程启动充电功能</div>
    </div>
    </div>
    <div class="m-peculiarity-item">
    <div class="m-pe-icon m-iconk9"></div>
    <div class="m-pe-text">
    <div>无感充电功能</div>
    </div>
    </div>
    </div>
    <div class="m-data-explain">
    <div class="m-data-explain-item">
    <div class="m-de-item-num">即插即充<span></span></div>
    <div class="m-de-item-text">支持企业车辆无感</div>
    <div class="m-de-item-text">充电</div>
    </div>
    <div class="m-data-explain-item"></div>
    </div>
    <div class="m-data-explain">
    <div class="m-data-explain-item">
    <div class="m-de-item-num">节降成本<span></span></div>
    <div class="m-de-item-text">员工账号分时段充电</div>
    </div>
    <div class="m-data-explain-item">
    <div class="m-de-item-img2"></div>
    </div>
    </div>

    <div class="m-title-box" style="margin-top: 60px;">
    财务核算
    <div class="m-title-line"></div>
    </div>
    <div class="m-describe">
      方便企业管理企业账务明细以及员工账务明细，可支持实时查看管理。平台为企业提供在线申请发票的便捷入口。
    </div>
    <div class="m-peculiarity">
    <div class="m-peculiarity-item">
    <div class="m-pe-icon m-iconk6"></div>
    <div class="m-pe-text">
    <div>企业账户信息查看</div>
    </div>
    </div>
    <div class="m-peculiarity-item">
    <div class="m-pe-icon m-iconk7"></div>
    <div class="m-pe-text">
    <div>员工消费记录查看</div>
    </div>
    </div>
    <div class="m-peculiarity-item">
    <div class="m-pe-icon m-iconk8"></div>
    <div class="m-pe-text">
    <div>企业在线申请发票</div>
    </div>
    </div>
    </div>
    <div class="m-data-explain">
    <div class="m-data-explain-item">
    <div class="m-de-item-num">在线对账<span></span></div>
    <div class="m-de-item-text">平台提供多维度</div>
    <div class="m-de-item-text">财务报表</div>
    </div>
    <div class="m-data-explain-item"></div>
    </div>
    <div class="m-data-explain">
    <div class="m-data-explain-item">
    <div class="m-de-item-num">实时查看<span></span></div>
    <div class="m-de-item-text">支持企业账户明细</div>
    <div class="m-de-item-text">实时查看</div>
    </div>
    <div class="m-data-explain-item">
    <div class="m-de-item-img3"></div>
    </div>
    </div>


    <div class="m-title-box" style="margin-top: 60px;">
    合作模式
    <div class="m-title-line"></div>
    </div>
    <div class="m-describe">
      平台可为充电大客户提供多种合作模式，客户可根据自身情况选择适合自己的最优合作模式。
    </div>
    <div class="m-peculiarity" style="margin-bottom: 100px;">
    <div class="m-peculiarity-item">
    <div class="m-pe-icon m-iconk6"></div>
    <div class="m-pe-text">
    <div>充值返利</div>
    </div>
    </div>
    <div class="m-peculiarity-item">
    <div class="m-pe-icon m-iconk7"></div>
    <div class="m-pe-text">
    <div>消费返利</div>
    </div>
    </div>
    <div class="m-peculiarity-item">
    <div class="m-pe-icon m-iconk8"></div>
    <div class="m-pe-text">
    <div>协议电价</div>
    </div>
    </div>
    </div>
    <div class="m-data-explain">
      <div class="m-de-item-img3"></div>
    </div>
    </div>
    <div class="mobile-btns">
    <div class="m-btn" @click="gotoPage">我要加盟</div>
    </div>
    </div>
</template>
<script>
  export default {
    data() {
      return {
        tzData:{
          name:'',//姓名
          telephone:'',//
          email:'',//
          cityCode:'510000',//
          city:'四川省',//
          businessType:'大客户',//业务类型 1-大客户 2-投资 3-加盟
          addCity:'成都',//加盟城市
          addArea:'600㎡以下',//加盟面积
          addCharging:'60kw以下',//充电桩
          addCooperationMode:'建站方案策划',//合作模式
          addEstimatedCost: '50000.00',//加盟预计费用
          path:'/intelligentlogistics',
        }
      }
    },
    mounted() {},
    methods: {
      gotoPage(){
        this.$router.push({
          name: 'mobileApply',
          params: this.tzData
        });
      },
    },
  }

</script>
<style src="./../../styles/mobile.less" lang="less" scoped></style>
